/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBeehive = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17 21a3 3 0 0 0 2.79-4.105 3.001 3.001 0 0 0 0-5.79 3.001 3.001 0 0 0-2-4A3 3 0 0 0 15 3H9a3 3 0 0 0-2.79 4.105 3.001 3.001 0 0 0-2 4 3.001 3.001 0 0 0 0 5.79A3 3 0 0 0 7 21zM6 18a1 1 0 0 1 1-1h2v2H7a1 1 0 0 1-1-1zm9 1v-2h2a1 1 0 1 1 0 2zm-.764-4c-.55-.614-1.348-1-2.236-1s-1.687.386-2.236 1H5a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2zM6 10a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1zm2-4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBeehive as Beehive };
